import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { store } from './store/store';
import './styles/legacy.css';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
        <Toaster
          position="bottom-center"
          toastOptions={{
            duration: 3000,
            className: 'tl-toast',
            style: {
              background: '#630F12',
              color: '#F6E9B1',
              borderRadius: 0,
              border: '1px solid #C6A04A',
              padding: '12px 18px',
            },
            success: { iconTheme: { primary: '#43B228', secondary: '#F6E9B1' } },
            error: { iconTheme: { primary: '#C6A04A', secondary: '#630F12' } },
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);
